import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { useEffect, useState } from 'react';

const useAnimations = (longDelayedLoading: boolean, showAnimationControls: boolean) => {
	const { hasAnimations, playAnimations, stopAllAnimations, animationsConfig } = useZakeke()
	const [isActive, setIsActive] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);

	// TODO consider sceneConfig value animations.runAtStart
	useEffect(() => {
		console.debug("long delayed start of animations", animationsConfig)
		if (hasAnimations() && !longDelayedLoading && showAnimationControls) {
			setIsActive(true)
			setIsPlaying(animationsConfig?.runAtStart ?? false)
		}
		// this is only to trigger a rerender for when the sceneIsLoaded
	}, [longDelayedLoading, showAnimationControls, hasAnimations, animationsConfig]);

	useEffect(() => {
		if (isPlaying) {
			playAnimations()
		} else {
			stopAllAnimations();
		}
	}, [isPlaying]);

	const toggleAnimations = () => {
		if (isActive) {
			setIsPlaying((prev) => !prev)
		}
	}

	return [isActive, isPlaying, toggleAnimations] as const;
}

export default useAnimations